import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {Game} from "../Game";
import {gsap} from "gsap";
import {IMonsterWalk} from "../server/IData";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";

export class NormalResultPresentation implements FlowStatePresentation {
    protected _tl: gsap.core.Timeline | undefined;

    public start(flowStateController: FlowStateController): void {
        const mxPos: IMonsterWalk = Game.model.gameData.mxLeftBottomCornerAtStart;
        let delay: number = 0.1;

        Game.visibleMonstersCount = Game.MONSTER_SYMBOLS.length;

        if (Game.apiPlugin.settings.get(APISetting.FAST_SPIN, false)) {
            delay = 0;
        }

        flowStateController.setSkipCallback(() => {
            this.skip();
        });

        this._tl = gsap.timeline({
            onComplete: () => {
                this.completePresentation(flowStateController);
            }
        });

        let reelCtrMX: number = 0,
            mxTraversed: boolean = false;

        this._tl.add(Game.symbolFloors.removeTrack(1));

        for (let i: number = 0; i < Game.ACTIVE_REELS_NUM; i++) {
            const symbols: string[] = Game.model.gameData.reels[i],
                reelStopAnimation: gsap.core.Timeline = gsap.timeline();

            reelStopAnimation.add(this.preventSkipOnLastReel(i, flowStateController));
            reelStopAnimation.add(Game.reelsView.reelModels[i].allIn(symbols));

            if (mxPos) {
                if ((mxPos.x > -1 && i >= mxPos.x && i < mxPos.x + 3) || ((i + mxPos.x <= 0) && (mxPos.x === -1))) {
                    this._tl.add(reelStopAnimation, (delay * reelCtrMX));
                    mxTraversed = true;
                } else {
                    if (mxTraversed) {
                        reelCtrMX = i;
                        mxTraversed = false;
                    }
                    this._tl.add(reelStopAnimation, (delay * reelCtrMX));
                    reelCtrMX++;
                }
            } else {
                this._tl.add(reelStopAnimation, (delay * i));
            }
        }

        const padding: number = Game.gameFlowController.calculatePaddingDuration(this._tl.totalDuration() - 0.1);
        if (padding > 0) {
            this._tl.shiftChildren(padding);
        }

        if (Game.wasMayhemBonusBuy()) {
            Game.reelCorners.bonusBuyMayhemLifeReset();
        }
    }

    protected preventSkipOnLastReel(reelId: number, flowStateController: FlowStateController): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        if (reelId === (Game.ACTIVE_REELS_NUM - 1)) {
            tl.add(() => {
                flowStateController.setSkipCallback();
            }); //prevents useless skips when last reel has started its stop anyway.
        }
        return tl;
    }

    protected skip(): void {
        this._tl?.timeScale(10);
    }

    protected completePresentation(flowStateController: FlowStateController): void {
        flowStateController.finish();
        delete this._tl;
    }
}